var map = {
	"./Calc_AUDIT/Info": [
		4076,
		4076
	],
	"./Calc_Alvarado/Info": [
		1237,
		1237
	],
	"./Calc_Apgar/Info": [
		3714,
		3714
	],
	"./Calc_BSA/Info": [
		6179,
		6179
	],
	"./Calc_BirthDate/Info": [
		7035,
		7035
	],
	"./Calc_CAGE/Info": [
		6097,
		6097
	],
	"./Calc_CFExercise/Info": [
		3586,
		3586
	],
	"./Calc_CKD/Info": [
		4033,
		1372
	],
	"./Calc_CURB/Info": [
		2101,
		2101
	],
	"./Calc_Chads2/Info": [
		9953,
		9953
	],
	"./Calc_CrCl/Info": [
		7424,
		7424
	],
	"./Calc_Eag/Info": [
		2539,
		2539
	],
	"./Calc_Epworth/Info": [
		5400,
		5400
	],
	"./Calc_Findrisk/Info": [
		1411,
		1411
	],
	"./Calc_Framingham/Info": [
		7102,
		7102
	],
	"./Calc_FraminghamIMC/Info": [
		3551,
		3551
	],
	"./Calc_GRACE/Info": [
		3261,
		3261
	],
	"./Calc_Geneve/Info": [
		5017,
		5017
	],
	"./Calc_Glasgow/Info": [
		6806,
		6806
	],
	"./Calc_HEART/Info": [
		796,
		796
	],
	"./Calc_Hasbled/Info": [
		2732,
		2732
	],
	"./Calc_IMC/Info": [
		752,
		752
	],
	"./Calc_IMPROVE/Info": [
		9652,
		9652
	],
	"./Calc_Killip/Info": [
		9354,
		9354
	],
	"./Calc_LRINEC/Info": [
		1497,
		1497
	],
	"./Calc_MEEM/Info": [
		1310,
		1310
	],
	"./Calc_MEWS/Info": [
		1892,
		1892
	],
	"./Calc_MOCA/Info": [
		4866,
		4866
	],
	"./Calc_NEWS/Info": [
		224,
		224
	],
	"./Calc_NIHSS/Info": [
		3204,
		3204
	],
	"./Calc_Oakland/Info": [
		2106,
		2106
	],
	"./Calc_PAAS/Info": [
		3248,
		3248
	],
	"./Calc_PERC/Info": [
		7006,
		7006
	],
	"./Calc_PESI/Info": [
		6962,
		6962
	],
	"./Calc_PEWS/Info": [
		7760,
		7760
	],
	"./Calc_PSI/Info": [
		4151,
		4151
	],
	"./Calc_Padua/Info": [
		5376,
		5376
	],
	"./Calc_RASS/Info": [
		4926,
		4926
	],
	"./Calc_SOFA/Info": [
		2556,
		2556
	],
	"./Calc_STOPBANG/Info": [
		3608,
		3608
	],
	"./Calc_Schwartz/Info": [
		9738,
		9738
	],
	"./Calc_TIMIIndex/Info": [
		2056,
		2056
	],
	"./Calc_TIMINStemi/Info": [
		86,
		86
	],
	"./Calc_TIMIStemi/Info": [
		645,
		645
	],
	"./Calc_Tc6m/Info": [
		9261,
		9261
	],
	"./Calc_UKPDS/Info": [
		7883,
		7883
	],
	"./Calc_WAT/Info": [
		2544,
		2544
	],
	"./Calc_WellsTEP/Info": [
		8539,
		8539
	],
	"./Calc_WellsTVP/Info": [
		5371,
		5371
	],
	"./Calc_WoodDownes/Info": [
		1157,
		1157
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5483;
module.exports = webpackAsyncContext;